// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-582f8e2f] .card-header{padding:.5rem .5rem !important}", ""]);
// Exports
module.exports = exports;
